export default __webpack_public_path__ + "static/Beach-Bandits-App-39268f337c69135f1ff85b10b83a1567.webp";